/*
 * @Author: Src
 * @Date: 2025-07-02 10:49:12
 * @LastEditTime: 2025-12-07 14:19:17
 * @LastEditors: Src
 * @FilePath: /work-station/src/common/enum/carShop.ts
 * @Description: 头部注释配置模板
 */
/** 门店字段枚举 */
export enum ECarShopField {
  ID = 'id', // id
  CAR_SHOP_CODE = 'carShopCode', // 门店编码
  CAR_SHOP_ID = 'carShopId', // 店铺ID
  POI = 'poi', // poi
  NAME = 'name', // 店铺名称
  // REGIONPID = 'regionpid', // 省ID
  // REGIONID = 'regionid', // 区域id
  // ADCODE = 'adcode', // 区县ID
  ADDRESS = 'address', // 地址明细
  START_TIME = 'startTime', // 第一次开始营业的时间
  AREA = 'area', // 营业面积
  HEAD_PICS = 'headPics', // 店铺头图
  COVER_PICS = 'coverPics', // 店铺封面图
  PICS = 'pics', // 店铺图片
  JOIN_VIDEOS = 'joinVideos', // 入驻门店视频
  TELS = 'tels', // 营业电话
  MANAGER_ID = 'managerId', // 联系人身份证
  IDENTITY_NUM = 'identityNum', // 联系人身份证号码
  SHOP_LICENSE = 'shopLicense', // 店铺营业执照
  BOSS_ID = 'bossId', // 联系人ID
  STAFF_ID = 'staffId', // 地推员id
  REMARK = 'remark', // 备注
  ONLINE_STATUS = 'onlineStatus', // 门店状态
  COMPANY = 'company', // 公司名称
  REVIEW_STATUS = 'reviewStatus', // 审核状态
  ONLINE_GD_STATUS = 'onlineGdStatus', // 线上状态
  ONLINE_GD_TIME = 'onlineGdTime', // 线上时间
  BUSINESS_TIME = 'businessTime', // 营业时间
  CP_ID = 'cpId', // 门店类型
  OFFLINE_GD_TIME = 'offlineGdTime', // 线下时间
  VIDEOS = 'videos', // 视频
  MAPLOCATION = 'mapLocation', // 地图位置
  MERCHANT_TELEPHONE = 'merchantTelephone',
  SHOP_USER_RELATIONS = 'shopUserRelations',
  OTHER_QUALIFICATIONS = 'otherQualifications',
  MAIN_BUSINESS_ATAG_NAME = 'mainBusinessAtagName',
  CERTIFICATE_ADDRESS_DISTANCE = 'certificateAddressDistance',
  ALBUM_IMAGES = 'albumImage',
  ALBUM_ADD_IMAGES = 'albumAddImage',
}
